import { useEffect } from 'react';
import { useAxoFormContext } from '../../context/AxoForm/AxoForm';

type TUseInitiatedTracking = {
  shouldTriggerOnInitiated?: boolean;
};

const useInitiatedTracking = ({
  shouldTriggerOnInitiated = false,
}: TUseInitiatedTracking) => {
  const { onInitiated } = useAxoFormContext();

  useEffect(() => {
    if (shouldTriggerOnInitiated) onInitiated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldTriggerOnInitiated]);

  return null;
};

export default useInitiatedTracking;
